import { render, staticRenderFns } from "./moreBed.vue?vue&type=template&id=3f816114"
import script from "./moreBed.vue?vue&type=script&lang=js"
export * from "./moreBed.vue?vue&type=script&lang=js"
import style0 from "./moreBed.vue?vue&type=style&index=0&id=3f816114&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports